module.exports = __webpack_public_path__ + "static/media/teatro.1fbde3bc.png";